import { render, staticRenderFns } from "./StudentAttendance.vue?vue&type=template&id=1cb5507f&scoped=true"
import script from "./StudentAttendance.vue?vue&type=script&lang=js"
export * from "./StudentAttendance.vue?vue&type=script&lang=js"
import style0 from "./StudentAttendance.vue?vue&type=style&index=0&id=1cb5507f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb5507f",
  null
  
)

export default component.exports